export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14155.d25ced9c.jpg";